// extracted by mini-css-extract-plugin
module.exports = {"createAccount":"CreateAccount_createAccount__SV_bO","title":"CreateAccount_title__SJ_BA","content":"CreateAccount_content__MDN0G","button":"CreateAccount_button__iuI1X"};